import { render, staticRenderFns } from "./IconsLoader.vue?vue&type=template&id=6f895398&scoped=true&"
import script from "./IconsLoader.vue?vue&type=script&lang=js&"
export * from "./IconsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f895398",
  null
  
)

export default component.exports